import { Navigate, Outlet, useLocation } from "react-router-dom";
import { CUSTOMER_TOKEN } from "../../constants/constants";
import { savePostAuthRedirect } from "../../utils/auth_redirect";

function ProtectedRoute() {
  const token = localStorage.getItem(CUSTOMER_TOKEN);
  const location = useLocation();

  if (!token) {
    savePostAuthRedirect(`${location.pathname}${location.search}`);
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
